import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';
import { StyledTooltip } from 'styles/common';

import { LockIcon } from 'constants/icons';
import theme from 'constants/theme';

import { StarRating } from './StarRating';

export const FeedbackCard = ({ saveRating, prevVal, isDisabled }) => (
  <Grid>
    <Grid container direction="row">
      <StyledTooltip title="Only visible to you">
        <Box>
          <LockIcon size="fixed12px" color={theme.palette.text.primary} rightGutter={1} />
        </Box>
      </StyledTooltip>
      <Typography variant="body2">How would you rate your overall satisfaction with this 1:1?</Typography>
    </Grid>

    <StarRating
      prevVal={prevVal}
      isDisabled={isDisabled}
      style={{ marginLeft: '-1rem', marginTop: '1rem' }}
      size="fixed32px"
      onChange={saveRating}
    />
  </Grid>
);
